import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatSaleTypeModel } from 'src/app/model/cat-sale-type.model';
import { CatSaleTypeService } from 'src/app/services/cat-sale-type.service';

@Component({
  selector: 'app-modal-cat-sale-type',
  templateUrl: './modal-cat-sale-type.component.html',
  styleUrls: ['./modal-cat-sale-type.component.css']
})
export class ModalCatSaleTypeComponent implements OnInit {
  @Input() saleType: CatSaleTypeModel;
  @Input() mode: string;

  // estado pagina
  public viewStatus = 1;

  // mascaras
  public customPatterns = {
    'A': { pattern: new RegExp('[a-zA-Z0-9ñÑ ]') },
    'C': { pattern: new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]') },
    'N': { pattern: new RegExp('[0-9]') }
  };

  ////////////////
  constructor(
    private saleTypeService: CatSaleTypeService,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) { }
  ngOnInit() { }

  //
  isValid = () => {
    let valid = true;
    let errors = [];
    if (this.descriptionError()) errors.push('Necesita capturar una descripción.');
    if (this.descriptionLengthError()) errors.push('La descripción no puede exceder 100 caracteres.');
    if (errors.length > 0) {
      valid = false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', { enableHtml: true });
    }
    return valid;
  }
  save = () => {
    if (this.isValid()) {
      // mostrar spinner
      this.viewStatus = 0;
      // enviar informacion en mayusculas
      this.saleType.description = this.saleType.description.toUpperCase().trim();
      this.saleTypeService.save(this.saleType)
        .pipe(
          tap((resp: any) => {
            if (resp && resp.codeHttpStatus === 200) {
              this.modalService.dismissAll('success');
              this.toastr.success('El tipo de venta se guardó con éxito.');
            } else {
              this.viewStatus = 1;
              this.toastr.error(resp && resp.messageError ? resp.messageError : 'Ocurrió un error al intentar guardar el tipo de venta.');
            }
          }),
          catchError(error => {
            this.viewStatus = 1;
            const messageError = error && error.error && error.error.messageError;
            return of(this.toastr.error(messageError || 'Ocurrió un error al intentar guardar el tipo de venta.'));
          })
        )
        .subscribe();
    }
  }
  close = () => this.modalService.dismissAll();

  // HELPERS
  descriptionError = () => !this.saleType.description || this.saleType.description.trim() === '';
  descriptionLengthError = () => !!this.saleType.description && this.saleType.description.trim().length > 100;
}
